export default "__VITE_ASSET__D_GTf7_$__"